<template>
<svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-TiJiaoXian1`]" width="1em" height="1em" v-bind="$attrs"><path :fill="useCurrentColor ? 'currentColor' : '#F1DFFB'" d="M4.075 13.168H15.73V14.86H4.075z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.70166 4.00977C2.70166 2.9052 3.59709 2.00977 4.70166 2.00977H14.8638C15.9683 2.00977 16.8638 2.9052 16.8638 4.00977V14.1719C16.8638 15.2764 15.9683 16.1719 14.8638 16.1719H4.70166C3.59709 16.1719 2.70166 15.2764 2.70166 14.1719V4.00977ZM4.11377 4.42188C4.11377 3.86959 4.56148 3.42188 5.11377 3.42188H14.4517C15.0039 3.42188 15.4517 3.86959 15.4517 4.42188V11.6894H4.11377V4.42188ZM4.11377 13.3329V13.7598C4.11377 14.3121 4.56149 14.7598 5.11377 14.7598H6.27197V13.3329H4.11377ZM7.97998 14.7598H11.5852V13.3329H7.97998V14.7598ZM13.2932 14.7598H14.4517C15.0039 14.7598 15.4517 14.312 15.4517 13.7598V13.3329H13.2932V14.7598Z" :fill="useCurrentColor ? 'currentColor' : '#1A1A1A'"/></svg>
</template>
<script>

export default {
  name: 'IconTiJiaoXian1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
